// hooks/usePeriodEditing.ts
import { useCallback } from 'react';
import { dutyCodeToRow, isRowNominal } from '../HoursTable.utils';
import { CustomDutyLine } from 'RestAPIs/employees/hours-table/types';
import { PeriodEditingDeps } from '../HoursTable.types';

export function usePeriodEditing({
  apiRef,
  editingRowId,
  currentRow,
  setCurrentRow,
  setShowDutyPeriodDialog
}: PeriodEditingDeps) {
  const handlePeriodCellClick = useCallback(
    (params: any, event: any) => {
      if (params.field !== 'periods' && params.field !== 'dutyType') return;
      if (params.row.id !== editingRowId) return;
      if (isRowNominal(params.row)) return;
      event.stopPropagation();
      const rowWithUpdates =
        apiRef?.current?.getRowWithUpdatedValues<CustomDutyLine>(params.id);
      rowWithUpdates && setCurrentRow(rowWithUpdates);
      setShowDutyPeriodDialog(true);
    },
    [editingRowId, apiRef, setCurrentRow, setShowDutyPeriodDialog]
  );

  const handlePeriodSave = useCallback(
    (duty: any, periods: any[]) => {
      if (!currentRow) return;
      const updatedRow: CustomDutyLine = {
        ...currentRow,
        periods: [...periods],
        dutyId: duty?.value,
        displayDutyCode: duty?.value
      };

      const {
        periods: rowPeriods,
        dutyTime,
        dutyType
      } = dutyCodeToRow(updatedRow);

      apiRef?.current?.updateRows([{ id: updatedRow.id, dutyTime, dutyType }]);
      apiRef?.current?.setEditCellValue({
        id: updatedRow.id,
        field: 'periods',
        value: rowPeriods,
        debounceMs: 0
      });
      apiRef?.current?.setEditCellValue({
        id: updatedRow.id,
        field: 'displayDutyCode',
        value: updatedRow.displayDutyCode,
        debounceMs: 0
      });

      setCurrentRow(updatedRow);
    },
    [currentRow, apiRef, setCurrentRow]
  );

  return {
    handlePeriodCellClick,
    handlePeriodSave
  };
}
